/* 🤖 this file was generated by svg-to-ts */
export var GtdFlagWf = {
    name: 'wf',
    data: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"#fff\" d=\"M0 0h512v512H0z\"/><path fill=\"#002654\" d=\"M0 0h170.7v512H0z\"/><path fill=\"#ce1126\" d=\"M341.3 0H512v512H341.3z\"/></svg>"
};
